export function getSignupPromoRefUidKkr (optionValue, promoCode) {
  const normalizedPromoCode = String(promoCode || '').trim().toLowerCase()
  if (!normalizedPromoCode) return ''

  try {
    const promoCodeList = JSON.parse(optionValue || '[]')
    if (!Array.isArray(promoCodeList)) return ''

    const promoCodeItem = promoCodeList.find(item => {
      return String(item?.code || '').trim().toLowerCase() === normalizedPromoCode
    })

    return promoCodeItem?.kkr || ''
  } catch (e) {
    return ''
  }
}
